import { IAlertChangeType } from "../../../../@types/admin/AdminAlert";

type IBadgeStatus = "active" | "inactive" | "warning" | "error";

/**
 * Retool's `propertyTypeStatusColor` state (EN-5165): Created green, Changed
 * amber, Deleted red. The ticket asks for this to live in the portal as
 * presentation, not in the API — so the API sends the word and this maps it
 * to a badge.
 *
 * "Unknown" is the API's stand-in for a django-simple-history marker we don't
 * recognise. Retool's CASE returned null there and rendered a blank tag,
 * which read as "no change" rather than "a change of an unknown kind".
 */
export function alertChangeBadgeStatus(
  changeType: IAlertChangeType | string
): IBadgeStatus {
  switch (changeType) {
    case "Created":
      return "active";
    case "Changed":
      return "warning";
    case "Deleted":
      return "error";
    default:
      return "inactive";
  }
}
